import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";

export const useGeneralSetting = () => {


    const [configurationData, setConfigurationData] = useState([]);
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [previousData, setPreviousData] = useState([]);
    const tagRef = useRef()


    const getApplicationSetting = async () => {
        try {

            const res = await services.getInvokeRemote("GET", Urls("GETAPPLICATIONCONFIGURATION"))
            if (!res?.body?.error_status) {
                setConfigurationData(res?.body?.data?.configuration_data)
                setPreviousData(res?.body?.data?.configuration_data)
            } else {
                setConfigurationData([])
                setPreviousData([])
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    useEffect(() => {
        getApplicationSetting()
    }, [])


    const handleAddMore = () => {
        const newConfig = {
            configuration_name: '',
            configuration_key: '',
            configuration_value: '',
            isNew: true,
            is_active: true
        };
        setConfigurationData((prev) => [newConfig, ...prev]);
    };

    const handleInputChange = (index, field, value) => {
        const updated = configurationData.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setConfigurationData(updated);
    };


    const upsertApplicationSetting = async (item, key, newvalue) => {
        try {
            const checkData = _.find(previousData, { configuration_id: item?.configuration_id })
            if (!item?.configuration_name?.trim()) {
                showInfo("Info", "Please enter a configuration name.")
                return
            }
            if (!item?.configuration_key?.trim()) {
                showInfo("Info", "Please enter a configuration key.")
                return
            }
            if (item?.configuration_name?.trim()) {
                const nameExists = _.some(configurationData, (config) =>
                    config.configuration_name?.trim()?.toLowerCase() === item.configuration_name?.trim()?.toLowerCase() &&
                    config.configuration_id !== item.configuration_id
                );
                if (nameExists) {
                    showInfo("Info", "Configuration name already exists.");
                    return;
                }
            }

            if (item?.configuration_key?.trim()) {
                const keyExists = _.some(configurationData, (config) =>
                    config.configuration_key?.trim()?.toLowerCase() === item.configuration_key?.trim()?.toLowerCase() &&
                    config.configuration_id !== item.configuration_id
                );
                if (keyExists) {
                    showInfo("Info", "Configuration key already exists.");
                    return;
                }
            }
            if (key === "configuration_value" && checkData?.configuration_value === item?.configuration_value) {
                return
            }

            const payload = {
                "configuration_id": item?.configuration_id || 0,
                "configuration_name": item?.configuration_name,
                "configuration_key": item?.configuration_key,
                "configuration_value": item?.configuration_value,
                "is_active": key === "is_active" ? newvalue : item?.is_active
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTAPPLICATIONCONFIGURATION"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                getApplicationSetting()

            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    return useMemo(() => ({
        configurationData, handleAddMore, handleInputChange, handleAddMore, upsertApplicationSetting,tagRef
    }), [configurationData, handleAddMore, handleInputChange, handleAddMore, upsertApplicationSetting,tagRef])
}